import { executeFileBrowserRead } from '../../../../files/browser/execute-file-browser-read.js';
import { resolveGitBranchScope } from '../../../../files/browser/resolve-git-branch-scope.js';
import type { ShortcutHandlerContext } from '../../../lib/types.js';
import { sendShortcutFileBrowserJson, sendShortcutJson } from '../../../lib/response.js';
import { parseGitScopeFromUrl, parseReadParams, parseReadPath } from './parse-query.js';
import { resolveShortcutSessionParent } from './resolve-session-parent.js';

export async function handleShortcutFileBrowserRead(
  ctx: ShortcutHandlerContext,
  sessionId?: string,
): Promise<void> {
  const reqPath = parseReadPath(ctx.url);
  if (reqPath == null) {
    sendShortcutJson(ctx.res, 400, { error: 'path required' });
    return;
  }

  const gitMsg = parseGitScopeFromUrl(ctx.url);
  const gitScope = resolveGitBranchScope({ id: 'shortcut', path: reqPath, ...gitMsg });
  if (
    gitMsg.source === 'git_branch' &&
    typeof gitMsg.repoRelPath === 'string' &&
    typeof gitMsg.branch === 'string' &&
    gitMsg.branch.trim().length > 0 &&
    !gitScope
  ) {
    sendShortcutJson(ctx.res, 400, { error: 'Invalid repository path' });
    return;
  }

  const sessionParentPath = await resolveShortcutSessionParent(ctx, sessionId);
  const result = await executeFileBrowserRead({
    msg: parseReadParams(ctx.url),
    reqPath,
    sessionParentPath,
    gitScope,
  });

  if ('error' in result) {
    sendShortcutJson(ctx.res, 400, { error: result.error });
    return;
  }

  const body: Record<string, unknown> = { content: result.content };
  if (result.totalLines != null) body.totalLines = result.totalLines;
  if (result.size != null) body.size = result.size;
  if (result.lineOffset != null) body.lineOffset = result.lineOffset;
  if (result.mimeType != null) body.mimeType = result.mimeType;
  if (result.resolvedPath != null) body.resolvedPath = result.resolvedPath;

  sendShortcutFileBrowserJson(ctx.res, 200, body, ctx.e2ee);
}
